import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Modal from '../../../../components/Modal';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { isActionAllowed } from '../../../../modules/contexts/Auth/RequireAuth';
import { getAllArps } from '../../../../services/contratos/arpsService';
import { useComponentesPaf } from '../../../../services/enum/useComponentesPaf';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useStatusArp } from '../../../../services/enum/useStatusArp';
import { useTipoItemAquisitivo } from '../../../../services/enum/useTipoItemAquisitivo';
import { getAllFornecedores } from '../../../../services/fornecedoresDAF/fornecedorService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import { swalErro } from '../../../../utils/swal';
import {
  headersArps,
  valoresExibidosOffCanvasArps,
} from '../../ProcessosAquisitivos/arps/auxiliarArps';
import subAbas from '../subabas';

const ProcessosJuridicosIndex: React.FC = () => {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Fornecedores')
      ?.value || '0',
  );

  // Verificar permissões para ações
  const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const TipoItemAquisitivo = useTipoItemAquisitivo();

  const componenteAf = useComponentesPaf();
  const statusArp = useStatusArp();

  const bin = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Sim' },
    { value: 2, label: 'Não' },
  ];

  const tituloModal = 'Nova Ata de Registro de Preço';
  const iconeModal = 'document';

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    interfaceSisAf: 0,
    moduloSisAf: 0,
    tipoTask: 0,
    responsavel: 0,
    dataEntrada: '',
    dataFinalizacao: '',
    funcionalidade: '',
    descricao: '',
    complexidade: '',
    reaproveitamentoCodigo: '',
    statusDesenvolvimento: '',
    pontosFuncionalidade: 0,
    pontosDesenvolvidos: 0,
    observacoes: '',
    level: '',
  });
  const [data, setData] = useState<any[]>([]);
  const [denominacoesData, setDenominacoesData] = useState<any[]>([]);
  const [kitsProdutoData, setKitsProdutoData] = useState<any[]>([]);
  const [fornecedoresData, setFornecedoresData] = useState<any[]>([]);
  const [proaqData, setProaqData] = useState<any[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);

  //Form do modal
  const [formNewArp, setFormNewArp] = useState({
    denominacaoGenericaId: 0,
    kitProdutosDAFId: 0,
    fornecedorId: 0,
    componenteAf: 0,
    tipoItemAquisitivo: 0,
    vincularProaq: 0,
    proaqId: 0,
    proaqLabel: '',
  });

  // Função para converter o valor de `componenteAf`
  const getComponenteAfLabel = (value: number) => {
    const map: Record<number, string> = {
      1: 'basico',
      2: 'especializado',
      3: 'estrategico',
    };
    return map[value] || null; // Retorna null se o valor não estiver mapeado
  };

  // Atualiza o `denominacoesData` quando `formNewArp.componenteAf` muda
  useEffect(() => {
    if (formNewArp.tipoItemAquisitivo === 1) {
      const fetchDenominacoes = async () => {
        const componenteLabel = getComponenteAfLabel(formNewArp.componenteAf);
        if (componenteLabel) {
          try {
            const response = await httpClient.get(
              `/api/denominacaogenerica/denominacoes-por-componente/${componenteLabel}`,
            );
            setDenominacoesData([
              { value: 0, label: 'Não informado' }, // Valor padrão
              ...response.data.map(
                (item: { id: number; denominacaoGenerica: string }) => ({
                  value: item.id,
                  label: item.denominacaoGenerica,
                }),
              ),
            ]);
          } catch (error) {
            console.error('Erro ao buscar denominações genéricas:', error);
          }
        } else {
          setDenominacoesData([]);
        }
      };

      fetchDenominacoes();
    } else {
      const fetchKits = async () => {
        const componenteNumber = formNewArp.componenteAf;
        if (componenteNumber) {
          try {
            const response = await httpClient.get(
              `/api/kitproduto/kits-por-componente/${componenteNumber}`,
            );
            setKitsProdutoData([
              { value: 0, label: 'Não informado' }, // Valor padrão
              ...response.data.map(
                (item: { id: number; kitProduto: string }) => ({
                  value: item.id,
                  label: item.kitProduto,
                }),
              ),
            ]);
          } catch (error) {
            console.error('Erro ao buscar kits:', error);
          }
        } else {
          setKitsProdutoData([]);
        }
      };

      fetchKits();
    }
  }, [formNewArp.tipoItemAquisitivo]);

  const fetchFornecedores = async () => {
    try {
      const fornecedoresData = await getAllFornecedores();
      setFornecedoresData(fornecedoresData);
    } catch (error: any) {
      if (isHttpError(error)) {
        console.log(error.response?.data.message);
      }
    }
  };

  useEffect(() => {
    if (formNewArp.vincularProaq === 1) {
      const fetchProaqs = async () => {
        const componenteLabel = getComponenteAfLabel(formNewArp.componenteAf);
        if (componenteLabel) {
          try {
            const response = await httpClient.get(
              `/api/proaq/proaqs-por-componente/${componenteLabel}`,
            );
            setProaqData([
              { value: 0, label: 'Não informado' }, // Valor padrão
              ...response.data.map(
                (item: { id: number; numeroProaq: string }) => ({
                  value: item.id,
                  label:
                    'ID: ' + item.id + ' --- Processo SEI: ' + item.numeroProaq,
                }),
              ),
            ]);
          } catch (error) {
            console.error('Erro ao buscar processos aquisitivos:', error);
          }
        } else {
          setProaqData([]);
        }
      };

      fetchProaqs();
    }
  }, [formNewArp.vincularProaq]);

  const fornecedoresOptions = [
    { value: 0, label: 'Não informado' },
    ...fornecedoresData.map((item) => ({
      value: item.id,
      label: item.nomeFantasia,
    })),
  ];

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllArps();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  useEffect(() => {
    fetchFornecedores();
    setDenominacoesData([{ value: 0, label: 'Não informado' }]);
    fetchData();
  }, []);

  const [statusInserirNewArp, setStatusInserirNewArp] = useState<boolean>(true);

  useEffect(() => {
    // Verifica se as condições são satisfeitas
    if (
      (formNewArp.denominacaoGenericaId === 0 &&
        formNewArp.kitProdutosDAFId === 0) ||
      formNewArp.fornecedorId === 0 ||
      formNewArp.vincularProaq === 0
    ) {
      setStatusInserirNewArp(true);
    } else {
      setStatusInserirNewArp(false);
    }

    if (formNewArp.vincularProaq === 1) {
      if (formNewArp.proaqId === 0) {
        setStatusInserirNewArp(true);
      } else {
        setStatusInserirNewArp(false);
      }
    }
  }, [formNewArp]);

  // const kitProdutosOptions = [
  //   { value: 0, label: 'Não informado' },
  //   ...kitsProdutoData.map((item) => ({
  //     value: item.id,
  //     label: item.nomeKit,
  //   })),
  // ];

  // const denominacoesGenericasOptions = [
  //   { value: 0, label: 'Não informado' },
  //   ...denominacoesData.map((item) => ({
  //     value: item.id,
  //     label: item.denominacaoGenerica,
  //   })),
  // ];

  const tableData = data.map((item) => {
    // Definindo cores de fundo com base no status do documento
    let statusBackgroundColor = '';

    const statusLabel = statusArp[item.statusArp].label;

    if (statusLabel === 'Não Publicado') {
      statusBackgroundColor = '#cfe9ff';
    } else if (statusLabel === 'Vigente') {
      statusBackgroundColor = '#008d00a7';
    } else if (statusLabel === 'Encerrado') {
      statusBackgroundColor = '#757575';
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = '#faffb4dd';
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = '#ffcecec3';
    }

    return {
      id: item.id,
      statusArp: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            borderRadius: '10px',
            padding: '5px',
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'center',
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          {statusLabel}
        </span>
      ),
      componenteAf: componenteAf[item.componenteAf].label,
      numeroSeiArp: item.numeroSeiArp,
      numeroArp: item.numeroArp,
      dataVigencia: formatDateSimp(item.dataVigencia),
      denominacaoGenerica: item.itemAdquirido,
      fornecedor: item.fornecedorNomeFantasia,
      valorTotal: '-',
      saldoArp: '-',
    };
  });

  const offCanvasData = data.map((item) => {
    // Definindo cores de fundo com base no status do documento
    let statusBackgroundColor = '';

    const statusLabel = statusArp[item.statusArp].label;

    if (statusLabel === 'Não Publicado') {
      statusBackgroundColor = '#cfe9ff';
    } else if (statusLabel === 'Vigente') {
      statusBackgroundColor = '#008d00a7';
    } else if (statusLabel === 'Encerrado') {
      statusBackgroundColor = '#757575';
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = '#faffb4dd';
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = '#ffcecec3';
    }

    // Calculando data de vigência
    const dataVigencia = new Date(item.dataPublicacao);
    dataVigencia.setDate(dataVigencia.getDate() + 365);

    // Formatando a data de vigência
    const formattedDataVigencia = formatDateSimp(dataVigencia.toISOString());

    // Calcula o prazo como hoje - dataVigencia
    const hoje = new Date();
    const diferencaEmDias = Math.ceil(
      (dataVigencia.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24),
    );

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusArp: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            borderRadius: '10px',
            padding: '5px',
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'center',
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          {statusLabel}
        </span>
      ),
      componenteAf: componenteAf[item.componenteAf].label,
      itemAdquirido: (
        <b style={{ fontSize: '1.25rem' }}>{item.itemAdquirido}</b>
      ),
      fornecedorNomeFantasia: item.fornecedorNomeFantasia,
      leiLicitacao: item.leiLicitacao,
      numeroSeiArp: item.numeroSeiArp,
      numeroArp: item.numeroArp,
      dataPublicacao: formatDateSimp(item.dataPublicacao),
      dataVigencia: formattedDataVigencia,
      prazoVigencia: diferencaEmDias,

      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  // Funções Handle
  const handleClearModal = () => {
    setFormNewArp({
      ...formNewArp,
      denominacaoGenericaId: 0,
      kitProdutosDAFId: 0,
      fornecedorId: 0,
      componenteAf: 0,
      tipoItemAquisitivo: 0,
      vincularProaq: 0,
      proaqId: 0,
      proaqLabel: '',
    });
  };

  const handleShowModal = () => {
    handleClearModal();
    setShowModal((show) => !show);
  };

  const handleClickModalInserir = () => {
    if (
      formNewArp.tipoItemAquisitivo === 1 &&
      formNewArp.denominacaoGenericaId === 0
    ) {
      swalErro('Informe a <b>Denominação Genérica</b>!');
      return;
    }

    if (
      formNewArp.tipoItemAquisitivo === 2 &&
      formNewArp.kitProdutosDAFId === 0
    ) {
      swalErro('Informe a <b>Kit de Produtos DAF</b>!');
      return;
    }

    navigate('ficha/dadosgerais', { state: { formNewArp } });
  };

  const handleChangeModal = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    setFormNewArp((prev) => {
      const updatedForm = { ...prev, [name]: newValue };

      // Se o campo alterado for `proaqId`, atualiza o `proaqLabel`
      if (name === 'proaqId') {
        const selectedProaq = proaqData.find((item) => item.value === newValue);
        updatedForm.proaqLabel = selectedProaq
          ? selectedProaq.label.split('--- Processo SEI: ')[1]
          : '';
      }

      return updatedForm;
    });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'level' || name === 'statusDesenvolvimento') {
      // Permitir somente números, '<', '>', ou uma combinação destes com números
      if (
        /^[0-9]*$/.test(value) ||
        value === '<' ||
        value === '>' ||
        /^[<>][0-9]+$/.test(value)
      ) {
        setFormFiltros((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === 'interfaceSisAf' || name === 'moduloSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      interfaceSisAf: 0,
      moduloSisAf: 0,
      tipoTask: 0,
      responsavel: 0,
      dataEntrada: '',
      dataFinalizacao: '',
      funcionalidade: '',
      descricao: '',
      complexidade: '',
      reaproveitamentoCodigo: '',
      statusDesenvolvimento: '',
      pontosFuncionalidade: 0,
      pontosDesenvolvidos: 0,
      observacoes: '',
      level: '',
    });
  };

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <Modal
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
          modalSize="medio"
          size="lg"
        >
          <WorkspaceFicha>
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="30%">
                <Select
                  name="componenteAf"
                  value={formNewArp.componenteAf}
                  options={componenteAf}
                  onChange={handleChangeModal}
                  label="Componente AF"
                />
              </CustomCol>
              <CustomCol width="70%">
                <Select
                  name="tipoItemAquisitivo"
                  value={formNewArp.tipoItemAquisitivo}
                  options={TipoItemAquisitivo}
                  onChange={handleChangeModal}
                  label="Tipo de Item do Processo"
                  disabled={formNewArp.componenteAf === 0 ? true : false}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow style={{ marginTop: '10px' }}>
              {formNewArp.tipoItemAquisitivo &&
              formNewArp.tipoItemAquisitivo === 2 ? (
                <CustomCol>
                  <Select
                    name="kitProdutosDAFId"
                    value={formNewArp.kitProdutosDAFId}
                    options={kitsProdutoData}
                    onChange={handleChangeModal}
                    label="Kit de Produtos"
                    disabled={
                      formNewArp.tipoItemAquisitivo !== 2 ? true : false
                    }
                  />
                </CustomCol>
              ) : (
                <CustomCol>
                  <Select
                    name="denominacaoGenericaId"
                    value={formNewArp.denominacaoGenericaId}
                    options={denominacoesData}
                    onChange={handleChangeModal}
                    label="Denominação Genérica"
                    disabled={
                      formNewArp.tipoItemAquisitivo === 0 ? true : false
                    }
                  />
                </CustomCol>
              )}
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Select
                  name="fornecedorId"
                  value={formNewArp.fornecedorId}
                  options={fornecedoresOptions}
                  onChange={handleChangeModal}
                  label="Fornecedor"
                  disabled={
                    formNewArp.denominacaoGenericaId === 0 &&
                    formNewArp.kitProdutosDAFId === 0
                      ? true
                      : false
                  }
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="30%">
                <Select
                  name="vincularProaq"
                  value={formNewArp.vincularProaq}
                  options={bin}
                  onChange={handleChangeModal}
                  label="Vincular a um Proaq?"
                  disabled={formNewArp.fornecedorId === 0 ? true : false}
                />
              </CustomCol>
              <CustomCol width="70%">
                <Select
                  name="proaqId"
                  value={formNewArp.proaqId}
                  options={proaqData}
                  onChange={handleChangeModal}
                  label="Processo Aquisitivo"
                  disabled={formNewArp.vincularProaq != 1 ? true : false}
                />
              </CustomCol>
            </CustomRow>
            <BarraInferiorBotoes>
              <WorkspaceBotoes
                inserir
                inserirDisabled={statusInserirNewArp}
                onClickInserir={handleClickModalInserir}
              />
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </Modal>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="150px">
              <Input
                name="level"
                label="Level"
                value={formFiltros.level}
                id="level"
                onChange={handleChange}
                style={{ textAlign: 'right' }}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersArps}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasArps}
          tituloCanvas="ATAS DE REGISTRO DE PREÇOS"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={!canDownload}
          inserir
          inserirDisabled={!canInsert}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ProcessosJuridicosIndex;
